// Define language resources
import en_v1_features from '../features/i18n/en.json';
import pl_v1_features from '../features/i18n/pl.json';
import zh_v1_features from '../features/i18n/zh.json';
import en_v1_modals from '../modals/i18n/en.json';
import pl_v1_modals from '../modals/i18n/pl.json';
import zh_v1_modals from '../modals/i18n/zh.json';
import en_shared from '../v1/components/shared/i18n/en.json';
import pl_shared from '../v1/components/shared/i18n/pl.json';
import zh_shared from '../v1/components/shared/i18n/zh.json';
import en_v4_shared from '../v4/shared/i18n/en.json';
import pl_v4_shared from '../v4/shared/i18n/pl.json';
import zh_v4_shared from '../v4/shared/i18n/zh.json';
import en_measurements from './byModel/measurements/i18n/en.json';
import pl_measurements from './byModel/measurements/i18n/pl.json';
import zh_measurements from './byModel/measurements/i18n/zh.json';
import en_common_widgets from './patterns/widgets/i18n/en.json';
import pl_common_widgets from './patterns/widgets/i18n/pl.json';
import zh_common_widgets from './patterns/widgets/i18n/zh.json';
import en_ds from './design-system/i18n/en.json';
import pl_ds from './design-system/i18n/pl.json';
import zh_ds from './design-system/i18n/zh.json';
import en_callouts from './features/callouts/i18n/en.json';
import pl_callouts from './features/callouts/i18n/pl.json';
import zh_callouts from './features/callouts/i18n/zh.json';
import en_callsheets from './features/callsheets/i18n/en.json';
import pl_callsheets from './features/callsheets/i18n/pl.json';
import zh_callsheets from './features/callsheets/i18n/zh.json';
import en_core from './features/core/i18n/en.json';
import pl_core from './features/core/i18n/pl.json';
import zh_core from './features/core/i18n/zh.json';
import en_productions from './features/productions/i18n/en.json';
import pl_productions from './features/productions/i18n/pl.json';
import zh_productions from './features/productions/i18n/zh.json';
import en_resources from './features/resources/i18n/en.json';
import pl_resources from './features/resources/i18n/pl.json';
import zh_resources from './features/resources/i18n/zh.json';
import en_resource_portal from './features/resource-portal/i18n/en.json';
import pl_resource_portal from './features/resource-portal/i18n/pl.json';
import zh_resource_portal from './features/resource-portal/i18n/zh.json';
import en_shortlists from './features/shortlists/i18n/en.json';
import pl_shortlists from './features/shortlists/i18n/pl.json';
import zh_shortlists from './features/shortlists/i18n/zh.json';
import en_visitor_management from './features/visitor-management/i18n/en.json';
import pl_visitor_management from './features/visitor-management/i18n/pl.json';
import zh_visitor_management from './features/visitor-management/i18n/zh.json';
import en_patterns from './patterns/i18n/en.json';
import pl_patterns from './patterns/i18n/pl.json';
import zh_patterns from './patterns/i18n/zh.json';

export const resources = {
  en: {
    shortlists: en_shortlists,
    core: en_core,
    v1_shared: en_shared,
    v4_shared: en_v4_shared,
    'resource-portal': en_resource_portal,
    callouts: en_callouts,
    callsheets: en_callsheets,
    productions: en_productions,
    resources: en_resources,
    measurements: en_measurements,
    ds: en_ds,
    patterns: en_patterns,
    'common-widgets': en_common_widgets,
    'visitor-management': en_visitor_management,
    'v1-features': en_v1_features,
    'v1-modals': en_v1_modals
  },
  pl: {
    shortlists: pl_shortlists,
    core: pl_core,
    v1_shared: pl_shared,
    v4_shared: pl_v4_shared,
    'resource-portal': pl_resource_portal,
    callouts: pl_callouts,
    callsheets: pl_callsheets,
    productions: pl_productions,
    resources: pl_resources,
    measurements: pl_measurements,
    ds: pl_ds,
    patterns: pl_patterns,
    'common-widgets': pl_common_widgets,
    'visitor-management': pl_visitor_management,
    'v1-features': pl_v1_features,
    'v1-modals': pl_v1_modals
  },
  zh: {
    shortlists: zh_shortlists,
    core: zh_core,
    v1_shared: zh_shared,
    v4_shared: zh_v4_shared,
    'resource-portal': zh_resource_portal,
    callouts: zh_callouts,
    callsheets: zh_callsheets,
    productions: zh_productions,
    resources: zh_resources,
    measurements: zh_measurements,
    ds: zh_ds,
    patterns: zh_patterns,
    'common-widgets': zh_common_widgets,
    'visitor-management': zh_visitor_management,
    'v1-features': zh_v1_features,
    'v1-modals': zh_v1_modals
  }
} as const;
